import { render, staticRenderFns } from "./SampleDetail.vue?vue&type=template&id=58f36cbe"
import script from "./SampleDetail.vue?vue&type=script&lang=js"
export * from "./SampleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports